import {
  getAbsenceQueryParams,
  getInitialVisibleRange,
  prefetchAbsences,
  prefetchAbsenceTypes,
  prefetchActivityTypeGroups,
  prefetchGroupStats,
  prefetchHolidays,
  prefetchResourceUsers,
} from '@src/features/absence';
import { Absence } from '@src/pages';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/absence')({
  loader: ({ context }) => {
    const { apiClient, auth } = context;
    prefetchResourceUsers(apiClient);
    prefetchAbsences(
      apiClient,
      getAbsenceQueryParams(getInitialVisibleRange()),
    );
    prefetchAbsenceTypes(apiClient);
    prefetchHolidays(apiClient);
    prefetchActivityTypeGroups(apiClient);
    if (auth.user?.id) {
      prefetchGroupStats(apiClient, auth.user.id);
    }
  },
  component: Absence,
});
